import { Source } from "react-native-fast-image";
import { ImageSourcePropType } from "react-native";
import Img from "./Img";

type ImgSourceT = ImageSourcePropType & Source;

export { ImgSourceT };

export default Img;
